export default "__VITE_ASSET__ClNx3jA7__"